import { birdieFooterLogo } from '@/assets';

export function Footer() {
  return (
    <footer className="bg-footer text-text-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-16">
          {/* Logo */}
          <div className="col-span-3 m-auto md:mx-0">
            <img src={birdieFooterLogo} alt="Birdie Gifts Logo" className="h-12" />
          </div>

          {/* Navigation */}
          <div>
            <nav className="space-y-3">
              <a href="https://birdiegifts.com/" target="_blank" className="block text-text-cream hover:text-text-cream/80 text-sm">
                Home
              </a>
              <a href="https://birdiegifts.com/services/" target="_blank" className="block text-text-cream hover:text-text-cream/80 text-sm">
                Our Services
              </a>
              <a href="https://birdiegifts.com/contact/" className="block text-text-cream hover:text-text-cream/80 text-sm">
                Contact the Birdies
              </a>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
              <a href="https://www.instagram.com/birdiegiftservices/" target="_blank">
                <span className="text-sm">Follow Us</span>
              </a>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <a href="mailto:info@birdiegifts.com" target="_blank">
                <span className="text-sm">info@birdiegifts.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright Bar - No border */}
        <div className="flex gap-8">
          <div className="text-sm">Copyright © 2025 Birdie Gifts. All Rights Reserved</div>
          <div></div> {/* Empty middle column for alignment */}
          <div className="flex items-center space-x-4 text-sm md:justify-end">
            <a href="https://birdiegifts.com/terms/" className="hover:text-text-cream/80">
              Terms and Conditions
            </a>
            <span className="">|</span>
            <a href="https://birdiegifts.com/privacy/" target="_blank" className="hover:text-text-cream/80">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
